"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return MismatchedCountryBanner;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _data = require("@sail/data");
const _safelinks = require("@stripe-internal/safe-links");
const _helpers = require("../helpers");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function MismatchedCountryBanner({ desiredCountry, id, dismissedCookieName, bodyMessage, linkMessage, localizedRedirectLink, styles, onClose, onRedirect }) {
    const [, setDismissedCookie] = (0, _data.useCookie)(dismissedCookieName);
    const [, setCountryCookie] = (0, _data.useCookie)('country');
    const handleDismiss = (0, _react.useCallback)(()=>{
        // We don't need to await this value because
        // we don't really care if it was "allowed" to set
        // or not, since we don't need to alter
        // any behavior as a result.
        setDismissedCookie('ack');
        onClose(id);
    }, [
        onClose,
        id,
        setDismissedCookie
    ]);
    const handleNavigate = (0, _react.useCallback)(()=>{
        setCountryCookie(desiredCountry);
        onRedirect === null || onRedirect === void 0 ? void 0 : onRedirect();
    }, [
        desiredCountry,
        setCountryCookie,
        onRedirect
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('MismatchedCountryBanner', styles),
        "data-testid": "mismatched-country-notification"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _helpers.getClassName)('MismatchedCountryBanner__Content', styles)
    }, /*#__PURE__*/ _react.default.createElement("p", {
        className: (0, _helpers.getClassName)('MismatchedCountryBanner__Body', styles),
        "data-testid": "body-container"
    }, bodyMessage), /*#__PURE__*/ _react.default.createElement(_safelinks.SafeAnchor, {
        className: (0, _helpers.getClassName)('MismatchedCountryBanner__Link', styles),
        href: localizedRedirectLink,
        onClick: handleNavigate,
        "data-testid": "link-container"
    }, linkMessage)), /*#__PURE__*/ _react.default.createElement("button", {
        className: (0, _helpers.getClassName)('MismatchedCountryBanner__CloseButton', styles),
        "aria-label": "Close",
        onClick: handleDismiss,
        "data-testid": "close-button",
        type: "button"
    }, /*#__PURE__*/ _react.default.createElement("svg", {
        width: "20px",
        height: "20px"
    }, /*#__PURE__*/ _react.default.createElement("path", {
        d: "M10 0a10 10 0 1 1 0 20 10 10 0 0 1 0-20zM7.17 5.76a1 1 0 0 0-1.41 1.41L8.59 10l-2.83 2.83a1 1 0 0 0 1.41 1.41L10 11.41l2.83 2.83a1 1 0 0 0 1.41-1.41L11.41 10l2.83-2.83a1 1 0 1 0-1.41-1.41L10 8.59z"
    }))));
}

//# sourceMappingURL=MismatchedCountryBanner.js.map